import { ExtendedFTNode, FTNodeOptions } from "src/typings/flexFramework/FlexComponent";
import { FlexModuleModelStore } from "../FlexModuleModelStore";

//TODO: shouldRender and hasRenderableChildren need unit tests

/**
 * Returns TRUE if flexTemplateNode is likely to have data required for rendering, or has any children
 * @param flexTemplateNode
 * @param flexModuleModelStore
 */
export const shouldRender = (flexTemplateNode: ExtendedFTNode, flexModuleModelStore: FlexModuleModelStore): boolean => {
  if (flexTemplateNode.childNodes && flexTemplateNode.childNodes.length > 0) {
    return true;
  }

  if (flexTemplateNode.options.clientSideOnly) {
    return true;
  }

  const microserviceResponse = flexModuleModelStore.modelMap.get(flexTemplateNode.id);

  if (microserviceResponse && !microserviceResponse.empty && !microserviceResponse.error) {
    return true;
  }

  return false;
};

/**
 * Inspects all child nodes of provided flexTemplateNode. Returns TRUE if any pass the shouldRender test. Only inspects immediate descendants.
 * @param flexTemplateNode
 * @param flexModuleModelStore
 */
export const hasRenderableChilren = (
  flexTemplateNode: ExtendedFTNode,
  flexModuleModelStore: FlexModuleModelStore
): boolean => {
  const children = flexTemplateNode.childNodes as ExtendedFTNode[];
  if (!children || children.length === 0) {
    return false;
  }

  const renderableChildren = children.filter((child) => shouldRender(child, flexModuleModelStore));

  return renderableChildren.length > 0;
};

/**
 * Verifies whether the options object is null, undefined or whether it is empty.
 * Useful to check options retrieved from normalizeOptionsData()
 * @param options
 */
export const hasEmptyOptions = (options: FTNodeOptions) =>
  !options || (Object.keys(options).length === 0 && options.constructor === Object);
